export default __webpack_public_path__ + "static/media/ResetPasswordIcon.4cef5d61.svg";